// Customer-facing cart classifier. Splits cart line items into two lanes —
// "professionals" (individual people billed per event: priest, chef, makeup,
// waiter, mehendi, choreographer, etc.) and "vendors" (everything else,
// including venue, decoration, catering, photography, DJ, flowers, equipment).
//
// Used by both the Instant Pricing sticky cart and the saved-package view on
// CustomerDashboard so the customer sees a consistent grouping wherever they
// review what they're paying for.

const PRO_KEYWORDS = [
  'professional',
  'priest',
  'purohit',
  'mehendi',
  'makeup',
  'choreograph',
  'chef',
  'biryani',
  'waiter',
  'server',
];

export const isProfessionalCategory = (category) => {
  const c = String(category || '').toLowerCase();
  return PRO_KEYWORDS.some((kw) => c.includes(kw));
};

export const splitCartByLane = (items) => {
  const professionals = [];
  const vendors = [];
  (items || []).forEach((it) => {
    if (isProfessionalCategory(it?.category)) professionals.push(it);
    else vendors.push(it);
  });
  return { professionals, vendors };
};

export const sumPrices = (items, getPrice) => {
  const fn = typeof getPrice === 'function' ? getPrice : (i) => Number(i?.price || 0);
  return (items || []).reduce((s, i) => s + (Number(fn(i)) || 0), 0);
};
